/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * TabPicker API
 * Pull tabs odds calculator and game management API with comprehensive validation
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateGame,
  Game,
  GameListResponse,
  GetApiGamesParams
} from '.././';

import { customFetch } from '.././mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary List user games
 */
export const getApiGames = (
    params?: GetApiGamesParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<GameListResponse>(
      {url: `/api/games`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiGamesQueryKey = (params?: GetApiGamesParams,) => {
    return [`/api/games`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiGamesQueryOptions = <TData = Awaited<ReturnType<typeof getApiGames>>, TError = null>(params?: GetApiGamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiGames>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGamesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGames>>> = ({ signal }) => getApiGames(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGames>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiGamesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGames>>>
export type GetApiGamesQueryError = null


export function useGetApiGames<TData = Awaited<ReturnType<typeof getApiGames>>, TError = null>(
 params: undefined |  GetApiGamesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiGames>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiGames>>,
          TError,
          Awaited<ReturnType<typeof getApiGames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiGames<TData = Awaited<ReturnType<typeof getApiGames>>, TError = null>(
 params?: GetApiGamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiGames>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiGames>>,
          TError,
          Awaited<ReturnType<typeof getApiGames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiGames<TData = Awaited<ReturnType<typeof getApiGames>>, TError = null>(
 params?: GetApiGamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiGames>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List user games
 */

export function useGetApiGames<TData = Awaited<ReturnType<typeof getApiGames>>, TError = null>(
 params?: GetApiGamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiGames>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiGamesQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create a new game
 */
export const postApiGames = (
    createGame: CreateGame,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<Game>(
      {url: `/api/games`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createGame, signal
    },
      options);
    }
  


export const getPostApiGamesMutationOptions = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGames>>, TError,{data: CreateGame}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiGames>>, TError,{data: CreateGame}, TContext> => {

const mutationKey = ['postApiGames'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiGames>>, {data: CreateGame}> = (props) => {
          const {data} = props ?? {};

          return  postApiGames(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiGamesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiGames>>>
    export type PostApiGamesMutationBody = CreateGame
    export type PostApiGamesMutationError = null | null

    /**
 * @summary Create a new game
 */
export const usePostApiGames = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGames>>, TError,{data: CreateGame}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiGames>>,
        TError,
        {data: CreateGame},
        TContext
      > => {

      const mutationOptions = getPostApiGamesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    